/**
 * @file
 * Block: Magazine.
 */
(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.medihumBlockMagazine = {
    attach: function (context, settings) {
      var $context = $(context);

      $('.block-views-blockmagazine-block-frontpage').once('magazine-process').each(function () {
        var $wrapper = $('.view-magazine', this);
        var $carousel = $wrapper.find('.view-content');

        $carousel.slick({
          arrows: true,
          infinite: false,
          slide: '.views-row.article',
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          prevArrow: '<span class="arrow-left"><i class="icon-arrow-left"></i></span>',
          nextArrow: '<span class="arrow-right"><i class="icon-arrow-right"></i></span>',
          variableWidth: true,
          responsive: [
            {
              breakpoint: 9999,
              settings: 'unslick'
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                variableWidth: true,
              }
            }
          ]
        });
      });
    }
  };

})(jQuery, Drupal);
